import { render, staticRenderFns } from "./AddArticleForm.vue?vue&type=template&id=fa60e9ee&scoped=true&"
import script from "./js/add-article-form.js?vue&type=script&lang=js&"
export * from "./js/add-article-form.js?vue&type=script&lang=js&"
import style0 from "./AddArticleForm.vue?vue&type=style&index=0&id=fa60e9ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa60e9ee",
  null
  
)

export default component.exports